<form [formGroup]="formGroup()">
  <div class="grid grid-cols-1 md:grid-cols-3 gap-2">
    <div class="flex flex-col gap-2">
      <label
        [for]="`panstwo-${schoolAddress() ? '-szkola' : ''}`"
        appRequiredLabel="panstwo"
        >Nazwa państwa</label
      >
      <input
        pInputText
        appControlError
        [id]="`panstwo-${schoolAddress() ? '-szkola' : ''}`"
        [value]="'Polska'"
        [readonly]="true"
      />
    </div>
    <div class="flex flex-col gap-2 w-full col-span-1">
      <label
        [for]="`gmina-${schoolAddress() ? '-szkola' : ''}`"
        appRequiredLabel="gminaDzielnica"
        >Gmina/Dzielnica</label
      >
      <p-auto-complete
        [inputId]="`gmina-${schoolAddress() ? '-szkola' : ''}`"
        appControlError
        appendTo="body"
        optionLabel="nazwa"
        styleClass="w-full"
        placeholder="Rozpocznij wprowadzanie nazwy (min. 3 znaki)"
        [suggestions]="gminaOptions()"
        (onSelect)="onGminaChange()"
        (onClear)="onGminaChange()"
        [ariaLabel]="'Gmina'"
        [emptyMessage]="emptySelectionMessage"
        [forceSelection]="true"
        [formControl]="formGroup().controls.gminaDzielnica"
        (completeMethod)="onFilterGmina($event)"
        [inputStyleClass]="'w-full'"
      >
        <!-- Sugestie (dropdown) - tylko opis -->
        <ng-template pTemplate="item" let-gmina>
          {{ gmina?.opis || gmina?.nazwa }}
        </ng-template>
      </p-auto-complete>
    </div>
    <div class="flex flex-col gap-2 w-full col-span-1">
      <label
        [for]="`miejscowosc-${schoolAddress() ? '-szkola' : ''}`"
        appRequiredLabel="miejscowosc"
        >Miejscowość</label
      >
      <p-auto-complete
        [inputId]="`miejscowosc-${schoolAddress() ? '-szkola' : ''}`"
        appControlError
        appendTo="body"
        optionLabel="nazwa"
        styleClass="w-full"
        placeholder="Rozpocznij wprowadzanie nazwy (min. 2 znaki)"
        [readonly]="!formGroup().controls.gminaDzielnica.value"
        [forceSelection]="true"
        [emptyMessage]="emptySelectionMessage"
        [ariaLabel]="'Miejscowość'"
        [suggestions]="miejscowoscOptions()"
        (onSelect)="onMiejscowoscChange()"
        (onClear)="onMiejscowoscChange()"
        [formControl]="formGroup()!.controls.miejscowosc"
        (completeMethod)="onFilterMiejscowosc($event)"
        [inputStyleClass]="'w-full'"
      />
    </div>
    <div class="flex flex-col gap-2 w-full col-span-1">
      <label
        [for]="`ulica-${schoolAddress() ? '-szkola' : ''}`"
        appRequiredLabel="ulica"
        >Ulica</label
      >
      <p-auto-complete
        [inputId]="`ulica-${schoolAddress() ? '-szkola' : ''}`"
        appControlError
        appendTo="body"
        optionLabel="nazwa"
        styleClass="w-full"
        placeholder="Rozpocznij wprowadzanie nazwy (min. 2 znaki)"
        [readonly]="!formGroup().controls.miejscowosc.value"
        [forceSelection]="true"
        [emptyMessage]="emptySelectionMessage"
        [ariaLabel]="'Ulica'"
        [suggestions]="uliceOptions()"
        [formControl]="formGroup()!.controls.ulica"
        (completeMethod)="onFilterUlica($event)"
        [inputStyleClass]="'w-full'"
      />
    </div>
    <div class="flex flex-col gap-2">
      <label
        [for]="`numerDomu-${schoolAddress() ? '-szkola' : ''}`"
        appRequiredLabel="nrDomu"
        >Numer domu</label
      >
      <input
        pInputText
        appControlError
        [id]="`numerDomu-${schoolAddress() ? '-szkola' : ''}`"
        [formControl]="formGroup().controls.nrDomu"
      />
    </div>
    <div class="flex flex-col gap-2">
      <label
        [for]="`numerLokalu-${schoolAddress() ? '-szkola' : ''}`"
        appRequiredLabel="nrLokalu"
        >Numer lokalu</label
      >
      <input
        pInputText
        appControlError
        [id]="`numerLokalu-${schoolAddress() ? '-szkola' : ''}`"
        [formControl]="formGroup().controls.nrLokalu"
      />
    </div>
    <div class="flex flex-col gap-2">
      <label
        [for]="`kodPocztowy-${schoolAddress() ? '-szkola' : ''}`"
        appRequiredLabel="kodPocztowy"
        >Kod pocztowy</label
      >
      <p-input-mask
        [style]="{ width: '100%' }"
        appControlError
        [inputId]="`kodPocztowy-${schoolAddress() ? '-szkola' : ''}`"
        [formControl]="formGroup().controls.kodPocztowy"
        mask="99-999"
        placeholder="XX-XXX"
      ></p-input-mask>
    </div>
    <div class="flex flex-col gap-2">
      <label
        [for]="`poczta-${schoolAddress() ? '-szkola' : ''}`"
        appRequiredLabel="poczta"
        >Poczta</label
      >
      <input
        pInputText
        appControlError
        [id]="`poczta-${schoolAddress() ? '-szkola' : ''}`"
        [formControl]="formGroup().controls.poczta"
      />
    </div>
  </div>
</form>
